import { toCamelCase } from "@/scripts/helpers/library";

const contactPage = window.location.pathname === "/contact";
const apiContactUsPage = window.location.pathname === "/api-contact-us";
const apiPages = window.location.pathname.startsWith("/developers");
const fillOutPdfPages = window.location.pathname.startsWith("/fill-out-and-edit-pdf");

export const onRegistration = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "SNRegistration"
  });
};

export const onTrialPurchased = email => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "SNFreeTrial"
  });
};

export const onRegularFreeTrialActions = (provider, action) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "CustomEvt",
    eventCategory: "SN-Auth",
    eventAction: action,
    eventLabel: provider
  });
};

export const onLeadFormSubmitCustomEvt = (checkedApi, formBtnText) => {
  window.dataLayer = window.dataLayer || [];
  let eventData = {
    event: "CustomEvt",
    eventAction: "Form submit",
    eventCategory: "Landing"
  };

  if (contactPage && checkedApi === "on") {
    eventData.eventLabel = formBtnText + ", Interested in API (Yes)";
  } else if (apiContactUsPage) {
    eventData.eventLabel = formBtnText + ", Interested in API (Yes)";
  } else if (apiPages) {
    eventData.eventLabel = formBtnText + ", API";
  }

  window.dataLayer.push(eventData);
};

export const onCEApiLeadformSubmit = (form, select2, checkedApi) => {
  window.dataLayer = window.dataLayer || [];
  const eventData = {
    event: "CE_apiLeadform_submit"
  };

  if (select2.length > 0) {
    const epNameSelect = form.find(".select2-hidden-accessible option:first").text().replace(/[^a-zA-Z\s]/g, "").toLowerCase().trim();
    const epValueSelect = form.find(".select2-selection .select2-selection__rendered").text().replace(/[^\d.\s+-]/g, "");

    eventData.pairs = [{
      ep_name: toCamelCase(epNameSelect),
      ep_value: epValueSelect,
    }];
  }

  if ((contactPage && checkedApi === "on") || apiContactUsPage || apiPages) {
    window.dataLayer.push(eventData);
  }
};

export const onCESampleView = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "CE_sample_view"
  });
};

export const onCETryNowClick = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "CE_tryNow_click"
  });
};

export const onCEGetFormClick = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "CE_getForm_click"
  });
};

export const onCETryTemplateClick = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "CE_tryTemplate_click"
  })
};

export const onCESignUpSubmit = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "CE_signUp_submit",
    pairs: [{
      ep_name: "via",
      ep_value: "one tap"
    }]
  })
};

export const onCeFreeTrialClick = () => {
  if (!fillOutPdfPages) {
    const buttons = document.querySelectorAll(".button, .link");
    const conditions = ["start", "free", "trial"];

    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      const isFreeTrialtutton = conditions.some(el =>
        button.innerHTML.toLowerCase().includes(el)
      );

      button.addEventListener("click", () => {
        if (isFreeTrialtutton && button.getAttribute("type") !== "submit") {
          window.dataLayer.push({
            event: "CE_freeTrial_click"
          });
        }
      });
    }
  }
};

export const onCELeadformClick = () => {
  const requestCallBtn = document.querySelectorAll("[data-micromodal-trigger='modal-form']") || "";
  const requestCallBusinessCloudBtn = document.querySelectorAll("[data-micromodal-trigger='modal-form-business-cloud']") || "";
  const requestContactBtn = document.querySelectorAll("[href *='/contact']") || "";

  const dataLayerPushEv = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "CE_leadform_click"
    });
  };

  if(requestContactBtn){
    requestContactBtn.forEach(e => e.addEventListener("click", dataLayerPushEv));
  }

  if(requestCallBtn){
    requestCallBtn.forEach(e => e.addEventListener("click", dataLayerPushEv))
  }
  if(requestCallBusinessCloudBtn){
    requestCallBusinessCloudBtn.forEach(e => e.addEventListener("click", dataLayerPushEv))
  }
};

export const onCELeadformSubmit = (form, select2, checkedApi, actionForm) => {
  window.dataLayer = window.dataLayer || [];
  const eventData = {
    event: "CE_leadform_submit",
  };

  if (select2.length > 0) {
    const epName = form.find(".select2-hidden-accessible option:first").text().replace(/[^a-zA-Z\s]/g, "").toLowerCase().trim();
    const epValue = form.find(".select2-selection .select2-selection__rendered").text().replace(/[^\d.\s+-]/g, "");

    eventData.pairs = [{
      ep_name: toCamelCase(epName),
      ep_value: epValue,
    }];
  }

  if (actionForm !== "/api/form") {
    if (!checkedApi && !apiContactUsPage) {
      window.dataLayer.push(eventData);
    }
  }
};

export const onCEApiSandboxSubmit = (actionForm) => {
  if (actionForm === "/api/form") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "CE_apiSandbox_submit"
    })
  }
};

export const onCEDocumentUpload = () => {
  if (fillOutPdfPages) {
    setTimeout(() => {
      const inputValue = $(".js-uploader").find("input");

      inputValue.change(function() {
        var fileSelected = $(this).val();
        if(fileSelected !== '') {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "CE_document_upload"
          })
        }
      });
    }, 1000);
  }
};


export const onCeFreeTrialSubmit = () => {
  const formFreeTrial = document.querySelectorAll("form");

  for (let i = 0; i < formFreeTrial.length; i++) {
    const form = formFreeTrial[i];

    form.addEventListener("submit", () => {
      if (
        form.hasAttribute("action") &&
        form.getAttribute("action").includes("purchase")
      ) {
        window.dataLayer.push({
          event: "CE_freeTrial_submit"
        });
      }
    });
  }
};

export const onCEDocToSendUpload = () => {
  const sendMyDocument = document.querySelector("#sendMyDocument");

  if (sendMyDocument) {
    sendMyDocument.addEventListener("change", function() {
      if (this.value) {
        window.dataLayer.push({
          event: "CE_docToSend_upload"
        });
      }
    });
  }
};

export const onCEDocToSignUpload = () => {
  const signMyDocument = document.querySelector("#signMyDocument");

  if (signMyDocument) {
    signMyDocument.addEventListener("change", function() {
      if (this.value) {
        window.dataLayer.push({
          event: "CE_signMyDoc_upload"
        });
      }
    });
  }
};
